import { BoxProps } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props<T> = {
  meta: T | any,
  data?: any,
  submitBtn?: JSX.Element,
} & Partial<TFormUIProps> & BoxProps;

export default React.forwardRef(function GenericFormUI<T>(
  { onSubmit, isLoading, isSubmitting, meta, data, submitBtn, ...rest }: Props<T>,
  ref?: any
) {
  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: data || {}, resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef,
  }));

  return (
    <CC.Box as={'form'} {...rest} onSubmit={handleSubmit(onSubmit)} ref={ref}>
      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        {displayCustomInputs<T>(meta, register, errors, isLoading)}
      </CC.SimpleGrid>

      {ref ? (
        <button type={'submit'} ref={submitBtnRef} style={{ display: 'none' }}>
          Enregistrer
        </button>
      ) : submitBtn || (
        <CC.HStack my={4} justifyContent={'flex-end'}>
          <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
        </CC.HStack>
      )}
    </CC.Box>
  );
});
